import React from "react";
import { useSelector } from "react-redux";
import { formatTitle } from "helpers/format-title";
import DiscountForm from "components/subscription-discounts/discount-form";
import DiscountCodes from "components/subscription-discounts/discount-codes";

const SubscriptionDiscounts = ({ data }) => {
	const { isActive } = useSelector(state => state.account.subscription);

	if (!isActive) return null;

	return (
		<div className="mt-5 md:mt-10">
			<div className="text-center">
				{data?.title && <h3>{formatTitle(data.title)}</h3>}
				{data?.description && <p className="text-secondary">{data.description}</p>}
				<DiscountCodes />
			</div>
			<DiscountForm data={data} />
		</div>
	);
};

export default SubscriptionDiscounts;